import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OemService {

  constructor() { }

  isOem(clientId: string) {
    return /oem/g.test(environment.apps[clientId]?.type);
  }
}
